import { useEnabledFeatures } from '../hooks/enabled-features/use-enabled-features';
import { FormRow } from '@cad-arc';
import { FormSelect } from '../../forms/integrated-form-controls/form-select';
import { EventLabelsView } from '../../event-labels-view';
import { useCallback } from 'react';
import { EventLabelOption, EventPanelFormType } from '@mark43/cad-api';
import { useFormContext } from 'react-hook-form';
import { useBootstrapState } from '../../bootstrap/bootstrap-provider';

export function EventFormLabelsSelect({ mode }: { mode?: 'read-only' }) {
    const { eventLabels: eventLabelsEnabled } = useEnabledFeatures();
    const form = useFormContext<EventPanelFormType>();
    const { eventPanelOptions } = useBootstrapState();

    const eventLabelsRenderViewMode = useCallback(
        (value: EventLabelOption[]) => <EventLabelsView labels={value} />,
        []
    );

    if (!eventLabelsEnabled) {
        return null;
    }

    return (
        <FormRow>
            <FormSelect
                control={form.control}
                label="Labels"
                name="eventLabels"
                options={eventPanelOptions?.eventLabelOptions || []}
                isMultiple
                truncateSelectedCount={2}
                renderViewMode={eventLabelsRenderViewMode}
                eventNotificationName="EVENT_LABELS"
                asEditable
                mode={mode}
            />
        </FormRow>
    );
}
